import request from '@/utils/request'

export function hospitalList() {
  return request({
    url: '/statistics/hospitalList',
    method: 'post',
    data: null
  })
}

export function deptList(param) {
  return request({
    url: '/statistics/deptList',
    method: 'post',
    data: {
      hospitalId: param
    }
  })
}

export function doctorList(hospitalId, departmentId) {
  return request({
    url: '/statistics/doctorList',
    method: 'post',
    data: {
      hospitalId: hospitalId,
      departmentId: departmentId
    }
  })
}

export function total(param) {
  return request({
    url: '/statistics/total',
    method: 'post',
    data: {
      hospitalId: param
    }
  })
}

export function today(param) {
  return request({
    url: '/statistics/today',
    method: 'post',
    data: {
      hospitalId: param
    }
  })
}

export function orderData(param) {
  return request({
    url: '/statistics/data',
    method: 'post',
    data: {
      hospitalId: param
    }
  })
}

export function chartDatas(hospitalId, timeType) {
  return request({
    url: '/statistics/chart',
    method: 'post',
    data: {
      hospitalId: hospitalId,
      timeType: timeType
    }
  })
}

export function chartDeptDatas(hospitalId, departmentId, timeType) {
  return request({
    url: '/statistics/chart/dept',
    method: 'post',
    data: {
      hospitalId: hospitalId,
      timeType: timeType,
      departmentId: departmentId
    }
  })
}

export function chartDoctorDatas(hospitalId, departmentId, doctorId, timeType) {
  return request({
    url: '/statistics/chart/user',
    method: 'post',
    data: {
      hospitalId: hospitalId,
      timeType: timeType,
      departmentId: departmentId,
      doctorId: doctorId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/dataCenter.js